export const operationSelector = [
  {
    text: '前十字韌帶',
    value: false,
    type: 1
  },
  {
    text: '後十字韌帶',
    value: false,
    type: 3
  },
  {
    text: '外側副韌帶',
    value: false,
    type: 3
  },
  {
    text: '內側副韌帶',
    value: false,
    type: 3
  },
  {
    text: '外側半月板',
    value: false,
    type: 2
  },
  {
    text: '內側半月板',
    value: false,
    type: 2
  },
  {
    text: '其他',
    value: false,
    type: 0
  }
]

export const CLManagementWays = Object.freeze([
  {
    text: '重建',
    type: 1
  },
  {
    text: '修補',
    type: 1
  },
  {
    text: '保守治療 (自行填寫)',
    type: 2
  }
])

export const noneACLManagementWay = Object.freeze([
  {
    text: '重建',
    type: 1
  },
  {
    text: '保守治療 (自行填寫)',
    type: 2
  }
])

export const materialSource = Object.freeze([
  {
    text: '自體',
    type: 1
  },
  {
    text: '異體',
    type: 1
  },
  {
    text: '人工',
    type: -1
  }
])

export const materialType = Object.freeze([
  {
    text: '膕膀肌肌腱',
    type: -1
  },
  {
    text: '髕骨韌帶',
    type: -1
  },
  {
    text: '其他 (自行填寫)',
    type: 3
  }
])

export const allogeneicMaterialType = Object.freeze([
  {
    text: '阿基里斯腱',
    type: -1
  },
  {
    text: '帶骨韌帶',
    type: -1
  },
  {
    text: '其他 (自行填寫)',
    type: 3
  }
])

export const MeManagementWays = Object.freeze([
  {
    text: '修補',
    type: -1
  },
  {
    text: '切除',
    type: -1
  },
  {
    text: '移植',
    type: -1
  },
  {
    text: '保守治療 (自行填寫)',
    type: 2
  }
])



// WEBPACK FOOTER //
// ./src/util/PHISelector.js